import type * as React from 'react';

import { cn } from '../../styles/lib/utils';

type FullScreenLoadingProps = React.ComponentProps<'div'> & {
  /** Text announced to screen readers while loading. */
  label?: string;
};

/** Spinner overlay that covers its nearest positioned ancestor while a page or section loads. */
function FullScreenLoading({ label = 'Loading', className, ...props }: FullScreenLoadingProps) {
  return (
    // biome-ignore lint/a11y/useSemanticElements: <output> is for form results, not a loading overlay
    <div
      role="status"
      data-slot="full-screen-loading"
      className={cn(
        'absolute left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-grey-10/75',
        className,
      )}
      {...props}
    >
      <svg
        className="h-8 w-8 motion-safe:animate-spin text-orange-50"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
}

export { FullScreenLoading, type FullScreenLoadingProps };
